import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  Picture,
  PictureWithoutId
} from '../../core/declarations/picture.interface';
import { IonicModule, IonicSlides } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { NgFor, NgIf } from '@angular/common';
import {
  CustomModalOptions,
  ModalAbstractComponent
} from '@bling-fe/shared/modals/base-modal';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { register } from 'swiper/element/bundle';
import { PinchZoomComponent } from '@meddv/ngx-pinch-zoom';

export interface GallerySlideshowModalProps {
  images: Array<Picture | PictureWithoutId>;
  initialIndex?: number;
}

@Component({
  selector: 'fl-gallery-slideshow-modal',
  templateUrl: './gallery-slideshow-modal.component.html',
  styleUrls: ['./gallery-slideshow-modal.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    NgIf,
    NgFor,
    IonicModule,
    TranslateModule,
    SvgIconComponent,
    PinchZoomComponent
  ],
  providers: [
    {
      provide: ModalAbstractComponent,
      useExisting: GallerySlideshowModalComponent
    }
  ]
})
export class GallerySlideshowModalComponent
  extends ModalAbstractComponent<GallerySlideshowModalProps, void>
  implements OnInit
{
  private static initialized = false;

  swiperModules = [IonicSlides];
  public static override modalOptions: CustomModalOptions = {
    cssClass: 'fl-gallery-slideshow-modal'
  };

  @ViewChild('swiperRef') swiperRef: ElementRef | undefined;

  renderSlideshow = false;
  activeSlide: number;

  swiperConfig: Record<string, unknown> = {
    loop: true,
    simulateTouch: true,
    initialSlide: 1
  };

  pinchZoomConfig: unknown = {
    'double-tap-scale': 2,
    'limit-zoom': 4,
    disableZoomControl: 'disable',
    backgroundColor: 'rgba(0,0,0,0)',
    overflow: 'visible'
  };

  get swiperInstance() {
    return this.swiperRef?.nativeElement.swiper;
  }

  constructor() {
    super();
    if (!GallerySlideshowModalComponent.initialized) {
      register();
      GallerySlideshowModalComponent.initialized = true;
    }
  }

  ngOnInit() {
    this.swiperConfig['initialSlide'] = this.props.initialIndex;
    this.activeSlide = this.props.initialIndex || 1;
    this.renderSlideshow = this.props.images.length > 1;
  }

  handleSlidePrevEnd(_event: unknown) {
    // if anybody wonders, getActiveIndex is bugged and returns wrong indexes ¯\_(ツ)_/¯
    this.activeSlide = (this.activeSlide - 1) % this.props.images.length;
    this.activeSlide =
      this.activeSlide === 0 ? this.props.images.length : this.activeSlide;
  }

  /**
   * IonSlideNextEnd is fired on initialization so it will correctly initiate activeSlide for us too.
   * (eg. index 0 becomes 1/3, index 2 becomes 2/3 etc)
   */
  handleSlideNextEnd(_event: unknown) {
    this.activeSlide = (this.activeSlide % this.props.images.length) + 1;
  }

  async toggleZoom(_event: unknown) {
    this.swiperInstance.zoom.toggle();
  }

  previous() {
    this.swiperInstance.slidePrev();
  }

  next() {
    this.swiperInstance.slideNext();
  }

  close() {
    this.dismiss();
  }
}
